import { Action, createReducer, on } from "@ngrx/store";
import { initialState, AuthState } from "./auth.state";

import { authActions } from "./auth.actions";
import {state} from "@angular/animations";

export const authReducer = createReducer(
  initialState,
  on(authActions.signupStarted, authActions.loginStarted, (state) => ({
    ...state,
    httpEventLoading: true,
    httpError: null,
  })),
  on(
    authActions.loginSucceeded,
    authActions.signupSucceeded,
    (state, { auth }) => {
      return {
        ...state,
        httpEventLoading: false,
        httpError: null,
        auth,
      };
    },
  ),
  on(authActions.signupFailed, authActions.loginFailed, (state, { error }) => {
    return {
      ...state,
      httpError: error,
      httpEventLoading: false,
    };
  }),
  on(authActions.fetchUserSucceeded, authActions.meUpdated, (state, { user }) => {
      return {
          ...state,
          user: user
      }
  }),
    on(authActions.authReady, (state, {user, isGuest}) => ({
        ...state,
        isGuest: isGuest,
        authReady: !!user,
    })),
);
